(function () {
  'use strict';

  if (window.__amahcQuizFunnel) {
    window.__amahcQuizFunnel.init(document);
    return;
  }

  const instances = new WeakSet();
  const testMode = new URLSearchParams(window.location.search).get('qf_test') === '1';
  const windows = ['Morning 9 to 12', 'Midday 12 to 2', 'Afternoon 2 to 5'];
  let instanceNumber = 0;

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
    });
  }

  function money(cents) {
    return new Intl.NumberFormat('en-AU', {
      style: 'currency', currency: 'AUD', minimumFractionDigits: cents % 100 ? 2 : 0,
      maximumFractionDigits: 2
    }).format(cents / 100);
  }

  function uuid() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    const bytes = new Uint8Array(16);
    try { window.crypto.getRandomValues(bytes); } catch (_) {
      for (let i = 0; i < 16; i += 1) bytes[i] = Math.floor(Math.random() * 256);
    }
    bytes[6] = (bytes[6] & 15) | 64;
    bytes[8] = (bytes[8] & 63) | 128;
    const hex = Array.from(bytes, function (b) { return b.toString(16).padStart(2, '0'); }).join('');
    return hex.slice(0, 8) + '-' + hex.slice(8, 12) + '-' + hex.slice(12, 16) + '-' + hex.slice(16, 20) + '-' + hex.slice(20);
  }

  function attribution() {
    let first = window.__amahcFirstTouch || {};
    try { first = JSON.parse(window.localStorage.getItem('amahc_ft') || 'null') || first; } catch (_) {}
    const landing = first.url || window.location.href;
    let original;
    try { original = new URL(landing); } catch (_) { original = new URL(window.location.href); }
    const tagged = /[?&](utm_[a-z]+|fbclid)=/i.test(original.search) ? original : new URL(window.location.href);
    const fbclid = tagged.searchParams.get('fbclid');
    function cookie(name) {
      try {
        const part = document.cookie.split(';').map(function (s) { return s.trim(); }).find(function (s) { return s.startsWith(name + '='); });
        return part ? decodeURIComponent(part.slice(name.length + 1)) : null;
      } catch (_) { return null; }
    }
    return {
      landingurl: landing, vid: first.vid || null, fbp: cookie('_fbp'),
      fbc: cookie('_fbc') || (fbclid ? 'fb.1.' + (Number(first.at) || Date.now()) + '.' + fbclid : null)
    };
  }

  // NSW public holidays: the sales team is off, so no "call me now" and no booking slots.
  const HOLIDAYS = ['2026-10-05', '2026-12-25', '2026-12-28', '2027-01-01', '2027-01-26', '2027-03-26', '2027-03-29',
    '2027-06-14', '2027-10-04', '2027-12-27', '2027-12-28', '2028-01-03', '2028-01-26'];
  function sydney(now, hours) {
    const values = {};
    new Intl.DateTimeFormat('en-AU', {
      timeZone: 'Australia/Sydney', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(now).forEach(function (part) { values[part.type] = part.value; });
    const today = new Date(Date.UTC(Number(values.year), Number(values.month) - 1, Number(values.day), 12));
    const minute = Number(values.hour) * 60 + Number(values.minute);
    let match = String(hours || '').match(/^([1-7])-([1-7])\s+([01]\d|2[0-3]):([0-5]\d)-([01]\d|2[0-3]):([0-5]\d)$/);
    if (!match || +match[1] > +match[2] || +match[3] * 60 + +match[4] >= +match[5] * 60 + +match[6]) {
      match = ['', '1', '5', '09', '00', '17', '00'];
    }
    const start = +match[3] * 60 + +match[4];
    const end = +match[5] * 60 + +match[6];
    const workday = function (day) { const n = day.getUTCDay() || 7; return n >= +match[1] && n <= +match[2] && HOLIDAYS.indexOf(day.toISOString().slice(0, 10)) === -1; };
    const open = workday(today) && minute >= start && minute < end;
    const next = new Date(today);
    if (minute >= start) next.setUTCDate(next.getUTCDate() + 1);
    while (!workday(next)) next.setUTCDate(next.getUTCDate() + 1);
    const weekday = new Intl.DateTimeFormat('en-AU', { timeZone: 'UTC', weekday: 'long' }).format(next);
    const days = [];
    const day = new Date(today);
    if (minute >= 16 * 60) day.setUTCDate(day.getUTCDate() + 1);
    while (days.length < 5) {
      if (workday(day)) {
        const label = new Intl.DateTimeFormat('en-AU', { timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'short' }).format(day).replace(/,/g, '');
        days.push({ id: day.toISOString().slice(0, 10), label: label, today: day.getTime() === today.getTime() });
      }
      day.setUTCDate(day.getUTCDate() + 1);
    }
    return { open: open, weekday: weekday, days: days, minute: minute, today: today.toISOString().slice(0, 10) };
  }

  function icon(name) {
    const paths = {
      joystick: '<path d="M5 22h22v7H5zM14 11h4v11h-4z" fill="currentColor"/><circle cx="16" cy="7" r="5" fill="#c52323" stroke="none"/>',
      lightning: '<path d="m18 2-13 17h10l-2 12L27 13H17Z" fill="#F3E600"/>',
      starburst: '<path d="m16 2 3 8 8-5-3 9 7 3-9 3 4 9-9-5-5 7-1-10-9-1 7-6-4-8 9 4Z"/>',
      wheel: '<circle cx="16" cy="16" r="13"/><circle cx="16" cy="16" r="4"/><path d="M3 15h9m8 0h9M16 20v9"/>',
      music: '<path d="M10 24V8l17-4v18M10 13l17-4"/><circle cx="6" cy="25" r="4"/><circle cx="23" cy="23" r="4"/>',
      film: '<circle cx="15" cy="15" r="13"/><circle cx="15" cy="15" r="2"/><circle cx="15" cy="7" r="2"/><circle cx="7" cy="15" r="2"/><circle cx="23" cy="15" r="2"/><circle cx="15" cy="23" r="2"/><path d="M15 28h16"/>',
      crown: '<path d="m4 12 4 14h16l4-14-8 7-4-13-4 13Z"/><circle cx="4" cy="9" r="2"/><circle cx="16" cy="3" r="2"/><circle cx="28" cy="9" r="2"/>',
      gas: '<rect x="9" y="8" width="14" height="22" rx="5"/><path d="M13 8V3h6v5M9 19h14"/>',
      truck: '<path d="M2 8h18v16H2zm18 6h6l4 6v4H20"/><circle cx="8" cy="25" r="3" fill="#F3E600"/><circle cx="25" cy="25" r="3" fill="#F3E600"/>',
      card: '<rect x="2" y="6" width="28" height="21" rx="3"/><path d="M2 13h28M7 21h6"/>',
      phone: '<path d="m9 3 4 6-4 3c2 4 5 7 9 9l3-4 7 4-2 7C13 31 1 19 4 5Z"/>',
      layers: '<path d="m16 2 14 8-14 8L2 10Zm-14 16 14 8 14-8M2 24l14 7 14-7"/>',
      shield: '<path d="M16 3 5 7v9c0 7 5 11 11 13 6-2 11-6 11-13V7Z"/><path d="m11 16 3.5 3.5L21 13"/>'
    };
    return '<svg class="lqf__icon" viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round" stroke-linecap="round" aria-hidden="true">' + (paths[name] || paths.layers) + '</svg>';
  }

  const arrow = '<svg class="lqf__arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M3 12h17m-7-7 7 7-7 7"/></svg>';
  function button(label, action, extra, style) {
    return '<button type="button" class="lqf__button' + (style ? ' lqf__button--' + style : '') + '" data-action="' + action + '" ' + (extra || '') + '>' + esc(label) + arrow + '</button>';
  }
  function pill(label) { return '<span class="lqf__pill">' + esc(label) + '</span>'; }
  function cleanTitle(title) { return String(title || '').replace(/\s*\(SHIPS IN\s+[^)]*\)\s*$/i, '').trim(); }

  function create(root) {
    const config = JSON.parse(root.querySelector('[data-lqf-config]').textContent);
    const category = root.dataset.category;
    const uid = 'lqf-' + (++instanceNumber);
    const q = function (selector) { return root.querySelector(selector); };
    const stage = q('[data-lqf-stage]');
    const dialog = q('[data-lqf-dialog]');
    const dialogContent = q('[data-lqf-dialog-content]');
    const products = new Map();
    const outbox = [];
    let sending = false;
    let renderTimer = 0;
    let restoreFocus = null;
    let animation = null;
    const state = {
      step: 0, mode: 'quiz', answers: {}, contact: { first_name: '', phone: '', email: '' }, errors: {},
      error: '', id: '', submitted: false, kit: false, addons: {}, addonPick: {}, leadPath: false, callChoice: '', callSlot: '',
      schedule: false, callDay: '', callWindow: '', clock: null, callDone: false, busy: false,
      cartError: '', cartAdded: false, cartComplete: false
    };

    function stepById(id) { return config.steps.find(function (s) { return s.id === id; }); }
    function options(step) {
      const list = (step.answers || []).slice();
      if (step.conditional && state.answers[step.conditional.when.step] === step.conditional.when.answer) list.unshift(step.conditional);
      if (step.custom && (!step.custom.when || state.answers[step.custom.when.step] === step.custom.when.answer)) list.push(step.custom);
      return list;
    }
    function choice(id) {
      const step = stepById(id);
      return step && options(step).find(function (a) { return a.id === state.answers[id]; });
    }
    // A step with showIf only exists in the flow when that earlier answer was given (e.g. cavity size after "Under the bench")
    function steps() { return config.steps.filter(function (s) { return !s.showIf || state.answers[s.showIf.step] === s.showIf.answer; }); }
    function currentStep() { return steps()[state.step]; }
    function detail(handle, kind) {
      const entry = products.get(handle);
      const product = entry && entry.product;
      let variant = product && product.variants.find(function (v) { return v.available; });
      if (product && kind === 'stairs') variant = product.variants.find(function (v) { return /stairs/i.test(v.title) && v.available; });
      if (product && kind === 'install') variant = product.variants[0];
      if (product && /^(7ft|8ft)$/.test(kind || '')) {
        variant = product.variants.find(function (v) { return new RegExp(kind[0] + '\\s*(?:ft|foot|feet)', 'i').test(v.title) && v.available; });
      }
      const valid = Boolean(product && variant && variant.available && Number(variant.id) > 0 && Number.isFinite(Number(variant.price)) && Number(variant.price) >= 0);
      return { status: entry ? entry.status : 'loading', product: product, variant: variant, valid: valid, price: valid ? Math.round(Number(variant.price)) : null };
    }
    function queueRender() {
      if (renderTimer || !root.isConnected) return;
      renderTimer = setTimeout(function () {
        renderTimer = 0;
        if (!root.isConnected) return;
        renderHero();
        if (state.mode !== 'contact' && !dialog.open) render(false);
      }, 16);
    }
    function loadProduct(handle) {
      if (!handle || products.has(handle)) return;
      const entry = { status: 'loading', product: null };
      products.set(handle, entry);
      const controller = typeof AbortController === 'function' ? new AbortController() : null;
      const timeout = setTimeout(function () {
        if (entry.status !== 'loading') return;
        entry.status = 'error';
        if (controller) controller.abort();
        queueRender();
      }, 12000);
      Promise.resolve().then(function () {
        return window.fetch('/products/' + encodeURIComponent(handle) + '.js', {
          credentials: 'same-origin', headers: { Accept: 'application/json' }, ...(controller ? { signal: controller.signal } : {})
        });
      }).then(function (response) {
        if (!response.ok) throw new Error('Product unavailable');
        return response.json();
      }).then(function (product) {
        if (entry.status !== 'loading') return;
        if (!product || !product.title || !Array.isArray(product.variants)) throw new Error('Product unavailable');
        entry.product = product;
        entry.status = 'ready';
      }).catch(function () { entry.status = 'error'; }).finally(function () {
        clearTimeout(timeout);
        queueRender();
      });
    }
    function allHandles() {
      const handles = new Set([config.hero.priceHandle, config.installHandle, config.kitHandle, config.cueHandle, config.underHandle, config.defaultHandle].concat(Object.values(config.couplerHandles || {})).filter(Boolean));
      config.steps.forEach(function (step) {
        (step.answers || []).concat(step.conditional || [], step.custom || []).forEach(function (a) { if (a.handle) handles.add(a.handle); });
        (step.groups || []).forEach(function (g) { g.answers.forEach(function (a) { if (a.handle) handles.add(a.handle); }); });
      });
      return Array.from(handles);
    }
    function imageHTML(item, className, alt) {
      let source = item.product && item.product.featured_image;
      if (source && typeof source === 'object') source = source.src;
      try {
        const url = new URL(source || '', window.location.href);
        if (!source || !/^https?:$/.test(url.protocol)) return '';
        url.searchParams.set('width', '800');
        return '<img class="' + className + '" src="' + esc(url.href) + '" alt="' + esc(alt || cleanTitle(item.product.title)) + '" width="600" height="600" decoding="async">';
      } catch (_) { return ''; }
    }
    function mainChoice() { const ids = [].concat(config.mainStep); for (let i = 0; i < ids.length; i++) { const c = choice(ids[i]); if (c) return c; } return null; }
    function mainHandle() { return category === 'keg' && state.answers.where === 'under' ? config.underHandle : ((mainChoice() || {}).handle || config.defaultHandle); }
    function couplerTypes() {
      // Keg: CUB brands pour on a D-type, Lion brands on an A-type, unknown brands get both
      if (category !== 'keg') return [];
      const picked = state.answers.brands || [];
      const groups = steps().filter(function (st) { return st.groups; }).reduce(function (all, st) { return all.concat(st.groups); }, []);
      const brands = groups.filter(function (g) { return g.id === 'brands'; }).reduce(function (all, g) { return all.concat(g.answers); }, []);
      const types = {};
      brands.forEach(function (a) { if (picked.includes(a.id) && a.coupler) { if (a.coupler === 'both') { types.d = true; types.a = true; } else types[a.coupler] = true; } });
      return ['d', 'a'].filter(function (t) { return types[t]; });
    }
    function build() {
      const requests = [];
      const main = mainHandle();
      if (main) requests.push({ handle: main });
      if (category === 'pool' || category === 'sauna') {
        if (state.answers.install && state.answers.install !== 'no') requests.push({ handle: config.installHandle, kind: state.answers.install === 'stairs' ? 'stairs' : 'install' });
        if (state.kit && !config.pdpResult) requests.push({ handle: config.kitHandle, kind: (choice('table') || {}).size });
        if (state.cue && config.cueHandle && state.answers.room === 'under') requests.push({ handle: config.cueHandle });
      }
      if (category === 'keg') {
        const groups = steps().filter(function (st) { return st.groups; }).reduce(function (all, st) { return all.concat(st.groups); }, []);
        groups.forEach(function (g) {
          g.answers.forEach(function (a) {
            const selected = g.multi ? (state.answers[g.id] || []).includes(a.id) : state.answers[g.id] === a.id;
            if (selected && a.handle && !a.noBuild && !pdpCovers(a.handle)) requests.push({ handle: a.handle });
          });
        });
        if (!pdpCovers(couplerKey())) couplerTypes().forEach(function (t) { if (config.couplerHandles && config.couplerHandles[t]) requests.push({ handle: config.couplerHandles[t] }); });
      }
      const items = requests.map(function (request) {
        const item = detail(request.handle, request.kind);
        return { ...item, handle: request.handle, title: item.product ? cleanTitle(item.product.title) : '', variant_id: item.variant ? Number(item.variant.id) : null };
      });
      if (config.pdpResult) Object.keys(state.addons).forEach(function (key) { const a = state.addons[key]; if (a && a.id) items.push({ status: 'ready', valid: true, price: a.price, handle: a.handle, title: a.title, label: a.label, full: a.full, variant_id: Number(a.id), ids: a.multi ? a.multi.split(',').map(Number) : null, addon: true }); });
      // Keg extras come from the PDP's own accessory cards, so hold the price until that page has loaded
      const waiting = Boolean(config.pdpAddonMap) && state.mode === 'result' && (pdp.status === 'idle' || pdp.status === 'loading');
      return { items: items, ready: Boolean(main) && !waiting && items.every(function (i) { return i.valid; }), total: items.reduce(function (sum, i) { return sum + (i.price || 0); }, 0) };
    }
    function canAdvance(step) {
      if (!step) return false;
      if (step.groups) return step.groups.every(function (g) {
        const ids = g.multi ? (state.answers[g.id] || []) : [state.answers[g.id]];
        return (!g.required || ids.some(Boolean)) && ids.every(function (id) {
          if (!id) return !g.required;
          const a = g.answers.find(function (answer) { return answer.id === id; });
          return a && (!a.handle || detail(a.handle).valid);
        });
      });
      const a = options(step).find(function (answer) { return answer.id === state.answers[step.id]; });
      if (!a || (a.handle && !detail(a.handle).valid)) return false;
      if (step.id === 'install' && a.id !== 'no' && !detail(config.installHandle, a.id === 'stairs' ? 'stairs' : 'install').valid) return false;
      return true;
    }
    function preselect(step) {
      if (!step || !step.preselect || state.answers[step.id]) return;
      const id = step.preselect.map[state.answers[step.preselect.step]];
      const answer = options(step).find(function (a) { return a.id === id; });
      if (answer && detail(answer.handle).valid) state.answers[step.id] = id;
    }
    function answerHTML(a, group, extra) {
      const selected = group.multi ? (state.answers[group.id] || []).includes(a.id) : state.answers[group.id] === a.id;
      const item = a.handle ? detail(a.handle) : null;
      const visual = group.type === 'products' || a.image === true || Boolean(a.imageUrl);
      if (item && item.status === 'loading') return '<div class="lqf__skeleton" role="status" aria-label="Loading ' + esc(a.label) + '"></div>';
      if (item && !item.valid) return '';
      let label = group.liveTitle && item ? cleanTitle(item.product.title) : a.label;
      let content = '';
      if (extra === 'custom') {
        content = pill(a.pill) + '<span>' + esc(a.label || 'Custom branded cabinet') + '</span>';
      } else {
        if (visual && item) content += imageHTML(item, 'lqf__product-image', label);
        else if (a.imageUrl) content += '<img class="lqf__product-image" src="' + esc(a.imageUrl) + '" alt="" width="600" height="600" decoding="async">';
        if (a.icon) content += icon(a.icon);
        content += '<span class="lqf__tile-copy"><span class="lqf__tile-label">' + esc(label) + '</span>' + (a.sub ? '<span class="lqf__tile-sub">' + esc(a.sub) + '</span>' : '') + '</span>';
        if (item && !((category === 'pool' && group.id === 'table') || category === 'keg' || category === 'pinball' || category === 'arcade' || category === 'sauna')) content += '<span class="lqf__tile-price">' + money(item.price) + '</span>';
        if (category === 'pool' && group.id !== 'room' && a.size && a.size === (choice('room') || {}).size) content += '<span class="lqf__fit">FITS YOUR ROOM</span>';
        const ships = item && item.product.title.match(/\(SHIPS IN\s+([^)]*)\)\s*$/i);
        if (ships && category !== 'keg' && category !== 'pool' && category !== 'arcade' && category !== 'sauna') content += '<span class="lqf__ship">Ships in ' + esc(ships[1].toLowerCase()) + '</span>';
        if (group.layout === 'list' && a.icon) content += '<span class="lqf__chevron" aria-hidden="true"></span>';
      }
      return '<button type="button" class="lqf__tile' + (visual && extra !== 'custom' ? ' lqf__tile--product' : '') + (extra === 'custom' ? ' lqf__custom' : '') + '" data-action="answer" data-step="' + esc(group.id) + '" data-value="' + esc(a.id) + '" aria-pressed="' + selected + '">' + content + '<span class="lqf__tile-check" aria-hidden="true">✓</span></button>';
    }
    function tilesHTML(step) {
      const list = options(step).filter(function (a) { return a !== step.custom; });
      if (category === 'pool' && step.id === 'table' && choice('room')) {
        const fit = choice('room').size;
        // Rooms under 4m only get the 7ft tables; everyone else sees all of them, best fit first
        const shown = state.answers.room === 'under' ? list.filter(function (a) { return a.size === '7ft'; }) : list;
        shown.sort(function (a, b) { return (b.size === fit) - (a.size === fit); });
        return '<div class="lqf__tiles' + (step.layout === 'list' ? ' lqf__tiles--list' : '') + (step.type === 'products' ? ' lqf__tiles--products' : '') + '">' + shown.map(function (a) { return answerHTML(a, step); }).join('') + '</div>';
      }
      return '<div class="lqf__tiles' + (step.layout === 'list' ? ' lqf__tiles--list' : '') + (step.type === 'products' ? ' lqf__tiles--products' : '') + (step.style ? ' lqf__tiles--' + step.style : '') + '">' + list.map(function (a) { return answerHTML(a, step); }).join('') + '</div>' + (step.custom && options(step).includes(step.custom) ? answerHTML(step.custom, step, 'custom') : '');
    }
    function roomHTML() {
      const answer = choice('room');
      if (!answer) return '';
      // Shortest wall runs top to bottom; the long wall is assumed 1.4m longer. Cue room is
      // measured from the playing surface (a 57in cue is about 1.45m), like a real room check.
      const scale = 42;
      const depthM = answer.length, lengthM = answer.length + 1.4;
      const length = lengthM * scale, depth = depthM * scale;
      const big = answer.size === '8ft';
      const playW = (big ? 2.24 : 1.98) * scale, playH = (big ? 1.12 : 0.99) * scale;
      const rail = 0.1 * scale;
      const roomX = 60 + (6.4 * scale - length) / 2, roomY = 22 + (5 * scale - depth) / 2;
      const px = roomX + (length - playW) / 2, py = roomY + (depth - playH) / 2;
      const x = px - rail, y = py - rail, tableW = playW + rail * 2, tableH = playH + rail * 2;
      const cue = 1.45 * scale;
      const cx = px - cue, cy = py - cue, cw = playW + cue * 2, ch = playH + cue * 2;
      const overlap = [
        [cx, cy, Math.max(0, roomX - cx), ch], [roomX + length, cy, Math.max(0, cx + cw - roomX - length), ch],
        [Math.max(cx, roomX), cy, Math.min(cw, length), Math.max(0, roomY - cy)], [Math.max(cx, roomX), roomY + depth, Math.min(cw, length), Math.max(0, cy + ch - roomY - depth)]
      ].filter(function (r) { return r[2] > 0 && r[3] > 0; }).map(function (r) { return '<rect x="' + r[0] + '" y="' + r[1] + '" width="' + r[2] + '" height="' + r[3] + '" fill="#c93030" opacity=".28"/>'; }).join('');
      const pockets = [[px,py],[px+playW/2,py-1],[px+playW,py],[px,py+playH],[px+playW/2,py+playH+1],[px+playW,py+playH]].map(function (p) { return '<circle cx="' + p[0] + '" cy="' + p[1] + '" r="3.6" fill="#111"/>'; }).join('');
      const short = overlap ? 'red shows where you would use a short cue' : 'full cues all round';
      // Crop the drawing to the room itself (plus the dimension label and caption) so the box has no dead space
      const vx = Math.min(roomX - 44, cx - 4), vy = Math.min(roomY, cy) - 6;
      const vw = Math.max(roomX + length, cx + cw) + 8 - vx, vh = Math.max(roomY + depth, cy + ch) + 30 - vy;
      const capY = Math.max(roomY + depth, cy + ch) + 20, capX = vx + vw / 2;
      return '<div class="lqf__room"><p class="lqf__caps">YOUR ROOM</p><svg viewBox="' + vx.toFixed(1) + ' ' + vy.toFixed(1) + ' ' + vw.toFixed(1) + ' ' + vh.toFixed(1) + '" role="img" aria-label="Room with a ' + depthM.toFixed(1) + 'm shortest wall and a ' + answer.size + ' table; ' + short + '">' +
        overlap + '<path d="M' + (roomX+52) + ' ' + roomY + 'H' + (roomX+length) + 'V' + (roomY+depth) + 'H' + roomX + 'V' + roomY + 'h18" stroke="#CFCCC4" stroke-width="6" fill="none"/>' +
        '<path d="M' + (roomX+18) + ' ' + roomY + 'v34q34 0 34-34" fill="none" stroke="#999" stroke-width="1"/>' +
        '<rect x="' + cx + '" y="' + cy + '" width="' + cw + '" height="' + ch + '" rx="8" fill="none" stroke="#C9BE00" stroke-width="2" stroke-dasharray="6 5"/>' +
        '<rect x="' + x + '" y="' + y + '" width="' + tableW + '" height="' + tableH + '" rx="5" fill="#5A3A26"/>' +
        '<rect x="' + px + '" y="' + py + '" width="' + playW + '" height="' + playH + '" rx="2" fill="#2E7D3A"/>' + pockets +
        '<path d="M' + (roomX-22) + ' ' + roomY + 'v' + depth + 'm-5 0h10M' + (roomX-27) + ' ' + roomY + 'h10" stroke="#111" fill="none"/>' +
        '<text x="' + (roomX-32) + '" y="' + (roomY+depth/2) + '" transform="rotate(-90 ' + (roomX-32) + ' ' + (roomY+depth/2) + ')" text-anchor="middle" font-size="12" fill="#111">' + depthM.toFixed(1) + 'm</text>' +
        '<text x="' + capX.toFixed(1) + '" y="' + capY.toFixed(1) + '" text-anchor="middle" font-size="11" fill="#111">' + answer.size + ' table · dashed line is full cue room</text></svg></div>' +
        '<div class="lqf__fit-row"><div class="lqf__verdict"><p>' + esc(answer.verdict) + '</p></div>' + cueHTML(answer) + '</div>';
    }
    function cueHTML(answer) {
      if (answer.id !== 'under' || !config.cueHandle) return '';
      const cue = detail(config.cueHandle);
      if (!cue.valid) return '';
      return '<button type="button" class="lqf__tile lqf__cue" data-action="cue" aria-pressed="' + Boolean(state.cue) + '">' + imageHTML(cue, 'lqf__cue-image', 'Short cue') +
        '<span class="lqf__cue-text">' + esc(cleanTitle(cue.product.title).replace(/^Premium /i, '')) + '<span class="lqf__tile-sub">Add to build</span></span><span class="lqf__tile-check" aria-hidden="true">' + (state.cue ? '✓' : '+') + '</span></button>';
    }
    function retryProductsHTML() {
      return '<button type="button" class="lqf__text" data-action="retry-products">Reload available products</button>';
    }
    function progressHTML() {
      const total = steps().length;
      const number = state.mode === 'contact' ? total : state.step + 1;
      return '<div class="lqf__progress" role="progressbar" aria-label="Quiz progress" aria-valuemin="0" aria-valuemax="' + total + '" aria-valuenow="' + number + '"><span class="lqf__progress-fill" style="width:' + (number / total * 100) + '%"></span></div>' +
        '<div class="lqf__step-meta"><span>' + (state.mode === 'contact' ? 'YOUR BUILD IS READY' : 'STEP ' + number + ' OF ' + total) + '</span><span>' + esc(config.label) + '</span></div>';
    }
    function stepHTML() {
      const step = currentStep();
      let content = progressHTML();
      if (step.badges) content += '<div class="lqf__badges"><img src="' + esc(root.dataset.badges) + '" alt="Pinball features" width="1000" height="250"><div class="lqf__badge-captions">' + step.badges.map(function (s) { return '<span>' + esc(s) + '</span>'; }).join('') + '</div></div>';
      content += '<h2 tabindex="-1" data-lqf-heading>' + esc(step.question) + '</h2>' + (step.help ? '<p class="lqf__help">' + esc(step.help) + '</p>' : '');
      if (step.groups) {
        content += step.groups.map(function (group) { return '<fieldset class="lqf__group"><legend>' + esc(group.question) + '</legend>' + (group.help ? '<p class="lqf__help">' + esc(group.help) + '</p>' : '') + tilesHTML(group) + '</fieldset>'; }).join('');
      } else content += tilesHTML(step);
      if (step.id === 'room') content += roomHTML();
      if (step.followup && step.followup.when.includes(state.answers[step.id])) content += '<div class="lqf__followup"><p>' + esc(step.followup.question) + '</p>' + tilesHTML(step.followup) + '</div>';
      if (step.id === 'install' && state.answers.install && state.answers.install !== 'no') {
        const install = detail(config.installHandle, state.answers.install === 'stairs' ? 'stairs' : 'install');
        if (!install.valid) content += '<p class="lqf__help">' + (install.status === 'loading' ? 'Checking installation availability...' : 'That installation option is unavailable. Try reloading or choose another option.') + '</p>';
      }
      if (Array.from(products.entries()).some(function (e) { return e[0] !== config.cueHandle && !(config.optionalHandles || []).includes(e[0]) && e[1].status === 'error'; })) content += retryProductsHTML();
      content += '<p class="lqf__error" role="status" data-lqf-step-error>' + esc(state.error) + '</p>';
      content += '<div class="lqf__nav">' + (state.step ? '<button type="button" class="lqf__text" data-action="back">Back</button>' : '') +
        button('Next', 'next', canAdvance(step) ? '' : 'disabled') + '</div>';
      return '<div class="lqf__quiz">' + content + '</div>';
    }
    function contactHTML() {
      return '<div class="lqf__quiz">' + progressHTML() + '<h2 tabindex="-1" data-lqf-heading>Where do we send your build?</h2>' + (category === 'pinball' ? '' : '<p class="lqf__help">A real person rings you, not a robot. Beshoy or Lachlan, usually the same day in business hours.</p>') +
        '<div class="lqf__contact" role="form" aria-label="Send my build">' + [
          ['first_name', 'First name', 'text', 'given-name'], ['phone', 'Mobile', 'tel', 'tel'], ['email', 'Email (optional)', 'email', 'email']
        ].map(function (field) {
          const error = state.errors[field[0]];
          return '<div class="lqf__field"><label for="' + uid + '-' + field[0] + '">' + field[1] + '</label><input id="' + uid + '-' + field[0] + '" data-contact="' + field[0] + '" name="' + field[0] + '" type="' + field[2] + '" autocomplete="' + field[3] + '" value="' + esc(state.contact[field[0]]) + '"' + (field[0] === 'email' ? '' : ' required') + ' aria-invalid="' + Boolean(error) + '"' + (error ? ' aria-describedby="' + uid + '-' + field[0] + '-error"' : '') + '>' +
            (error ? '<p class="lqf__error" id="' + uid + '-' + field[0] + '-error">' + esc(error) + '</p>' : '') + '</div>';
        }).join('') + button('SEE MY MATCH', 'submit') + '<p class="lqf__hours">We\'re open 9am to 5pm weekdays, Sydney time.</p></div>' +
        '<p class="lqf__error" role="status">' + esc(state.error) + '</p><button type="button" class="lqf__text" data-action="back">Back</button></div>';
    }
    function renderHero() {
      const h = config.hero;
      let price = '';
      if (h.priceHandle) {
        const item = detail(h.priceHandle);
        if (item.status === 'loading') price = '<span class="lqf__skeleton lqf__skeleton--price" role="status" aria-label="Loading live price"></span>';
        else if (item.valid) price = '<span class="lqf__hero-price">' + esc(h.pricePrefix || '') + money(item.price) + '</span>';
      }
      q('[data-lqf-hero-copy]').innerHTML = pill(h.pill) + '<a class="lqf__reviews" href="#reviews" data-action="reviews"><span aria-label="5 stars">★★★★★</span>4.6 from 587 Google reviews</a>' + '<h1>' + esc(h.headline) + '</h1>' + (h.sub ? '<p class="lqf__sub">' + esc(h.sub) + '</p>' : '') + price;
    }
    function linesHTML(priced) {
      return priced.items.map(function (i) { return '<div class="lqf__line"><span>' + esc(i.title) + '</span><span>' + (i.valid ? money(i.price) : 'Checking...') + '</span></div>'; }).join('');
    }
    function totalHTML(priced, was) {
      return '<div class="lqf__total"><span>Total</span><span class="lqf__total-amt">' + (was && priced.ready ? '<s class="lqf__was">' + money(was) + '</s>' : '') + '<strong' + (was ? ' class="lqf__sale"' : '') + ' data-lqf-total="' + priced.total + '">' + (priced.ready ? money(priced.total) : 'Checking...') + '</strong></span></div>';
    }
    // Sale pricing on the result card: compare-at strikethrough, the PDP's "Save $X" line and its sale sticker
    function saleInfo(priced, main) {
      const v = main.variant || {};
      const mainWas = Number(v.compare_at_price) > Number(main.price) ? Number(v.compare_at_price) : 0;
      const full = priced.items.reduce(function (sum, i, idx) { return sum + (idx === 0 ? (mainWas || i.price || 0) : (i.full || i.price || 0)); }, 0);
      const here = pdp.status === 'ready' && pdp.handle === main.handle;
      const big = config.priceIsTotal ? priced.total : main.price;
      const was = config.priceIsTotal ? (mainWas && full > priced.total ? full : 0) : mainWas;
      const pct = /(\d+)%/.exec((here && (pdp.saveText || (pdp.sticker && pdp.sticker.big))) || '');
      let save = '';
      if (was) save = !config.priceIsTotal && here && pdp.saveText ? pdp.saveText : 'Save ' + money(was - big) + ' · ' + (pct ? pct[1] : Math.floor((was - big) / was * 100)) + '% off';
      const settled = pdp.handle === main.handle && (pdp.status === 'ready' || pdp.status === 'error');
      return { big: big, was: was, save: settled ? save : '', settled: settled, totalWas: mainWas && full > priced.total ? full : 0, sticker: here && mainWas ? pdp.sticker : null };
    }
    // The photo sits inside a padded box (room for the sale sticker), so paint the box the photo's own backdrop colour
    function tintMedia() {
      Array.prototype.slice.call(root.querySelectorAll('.lqf__build-media img')).forEach(function (img) {
        const box = img.parentElement;
        const paint = function () {
          try {
            const c = document.createElement('canvas'); c.width = 4; c.height = 4;
            const ctx = c.getContext('2d');
            ctx.drawImage(img, 0, 0, Math.max(1, img.naturalWidth * 0.04), Math.max(1, img.naturalHeight * 0.04), 0, 0, 4, 4);
            const d = ctx.getImageData(0, 0, 4, 4).data; let r = 0, g = 0, b = 0, a = 0;
            for (let i = 0; i < d.length; i += 4) { r += d[i]; g += d[i + 1]; b += d[i + 2]; a += d[i + 3]; }
            const n = d.length / 4;
            // iOS Safari can hand back empty (transparent black) pixels before the photo is decoded, which painted
            // the box black. Only tint when the sample is solid and light; otherwise keep the default grey.
            if (a / n < 250 || (0.299 * r + 0.587 * g + 0.114 * b) / n < 170) return;
            box.style.backgroundColor = 'rgb(' + Math.round(r / n) + ',' + Math.round(g / n) + ',' + Math.round(b / n) + ')';
            mediaTint[img.currentSrc || img.src] = box.style.backgroundColor;
          } catch (_) {}
        };
        const known = mediaTint[img.currentSrc || img.src];
        if (known) box.style.backgroundColor = known;
        else if (img.complete && img.naturalWidth) paint();
        else img.addEventListener('load', paint, { once: true });
      });
    }
    function stickerHTML(st) {
      if (!st || !st.top) return '';
      return '<div class="lqf__stk" role="img" aria-label="' + esc(st.top + ' ' + st.big + ' ' + st.small) + '"><span class="lqf__stk-pill">' + esc(st.top) + '</span>' +
        '<span class="lqf__stk-flower"' + (st.art ? ' style="background-image:url(\'' + esc(st.art) + '\')"' : '') + '><b>' + esc(st.big) + '</b><i>' + esc(st.small) + '</i></span></div>';
    }
    function trustHTML(pool) {
      const items = pool ? [['truck', 'Installed by our own crews'], ['layers', '20mm honed slate'], ['shield', '24 month warranty']] : [category === 'arcade' || category === 'sauna' ? ['shield', '24 month warranty'] : ['truck', 'Ships Australia wide'], ['card', 'Interest-free options'], ['phone', 'Real people on the phone']];
      return '<div class="lqf__trust">' + items.map(function (i) { return '<div class="lqf__trust-item"><span class="lqf__trust-icon">' + icon(i[0]) + '</span><span>' + esc(i[1]) + '</span></div>'; }).join('') + '</div>';
    }
    function callStatus() {
      if (state.callChoice === 'scheduled') return "WE'LL RING YOU " + state.callSlot.replace(/ (9 to 12|12 to 2|2 to 5)$/, '').toUpperCase();
      if (state.callChoice === 'now') return state.clock.open ? "WE'LL RING YOU NOW" : "WE'LL RING YOU " + state.clock.weekday.toUpperCase() + ' MORNING';
      return 'WANT A HAND?';
    }
    function specialistsHTML() {
      return '<div class="lqf__specialists"><div class="lqf__specialists-inner"><figure class="lqf__specialist-photo"><img src="' + esc(root.dataset.specialists) + '" alt="Beshoy and Lachlan, your games room specialists" width="600" height="640" loading="lazy"><figcaption>BESHOY &amp; LACHLAN</figcaption></figure><div>' + pill(callStatus()) +
        '<h2>' + (category === 'pinball' && !config.pdpResult ? 'WE CHECK STAIRS, DOORS AND FLOORS BEFORE IT SHIPS' : 'TWO MINUTES WITH OUR TEAM BEATS AN HOUR OF GUESSING') + '</h2>' + button('Request a callback', 'callback') +
        '<a class="lqf__button lqf__button--outline" href="tel:' + esc((root.dataset.phoneNumber || '+61290558231').replace(/[^+\d]/g, '')) + '">Call ' + esc(root.dataset.phoneLabel || '02 9055 8231') + '</a></div></div></div>';
    }

    // ---- PDP on the result page (AMHC 12 Oct 2026): the matched product's own page supplies the
    // accessory builder ("Complete your setup") and the sections under the buy box (specs, Google
    // reviews, FAQ, bento), so the result reads like the PDP and stays in step with it.
    const mediaTint = {};
    const pdp = { handle: '', status: 'idle', addons: [], pct: 10, sections: [], sticker: null, saveText: '' };
    // Quiz extras (gas, couplers) that map onto one of the PDP's accessory cards: key -> { card, option }
    function couplerKey() { const t = couplerTypes(); return t.length === 2 ? 'coupler:ad' : t.length ? 'coupler:' + t[0] : ''; }
    function pdpCard(key) {
      const map = config.pdpAddonMap && config.pdpAddonMap[key];
      if (!map || pdp.status !== 'ready' || pdp.handle !== mainHandle()) return null;
      const card = pdp.addons.find(function (a) { return a.handle === map.card; });
      const opt = card && card.options.find(function (o) { return o.label === map.option; });
      return card && opt ? { card: card, opt: opt } : null;
    }
    function pdpCovers(key) { return Boolean(key && pdpCard(key)); }
    function seedAddons() {
      if (!config.pdpAddonMap) return;
      const sig = pdp.handle + '|' + JSON.stringify(state.answers);
      if (state.addonSeed === sig) return;
      state.addonSeed = sig;
      const keys = [];
      steps().filter(function (st) { return st.groups; }).forEach(function (st) { st.groups.forEach(function (g) { g.answers.forEach(function (a) {
        const selected = g.multi ? (state.answers[g.id] || []).includes(a.id) : state.answers[g.id] === a.id;
        if (selected && a.handle) keys.push(a.handle);
      }); }); });
      keys.push(couplerKey());
      keys.forEach(function (key) {
        const hit = pdpCard(key);
        if (!hit) return;
        state.addonPick[hit.card.key] = hit.opt.id;
        delete state.addons[hit.card.key];
        toggleAddon(hit.card.key);
      });
    }
    function addonLabel(a, opt) {
      const base = cleanTitle(a.title).replace(/^Kegerator\s+/i, '');
      if (opt && a.options.length > 1) return opt.label + ' ' + base.toLowerCase();
      return base;
    }
    function pdpSectionIds() { return config.pdpSections || ['specs', 'google_reviews', 'faq_stats', 'bento']; }
    function loadPdp(handle) {
      if (!handle || (pdp.handle === handle && pdp.status !== 'error')) return;
      pdp.handle = handle; pdp.status = 'loading'; pdp.addons = []; pdp.sections = []; pdp.sticker = null; pdp.saveText = '';
      window.fetch('/products/' + handle, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(function (html) {
        if (pdp.handle !== handle) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const wrap = doc.querySelector('[data-amhc-pww]');
        pdp.pct = wrap ? Number(wrap.getAttribute('data-pww-pct') || 10) : 10;
        pdp.addons = Array.prototype.slice.call(doc.querySelectorAll('.amhc-pww__card')).map(function (card, index) {
          const link = card.querySelector('.amhc-pww__nm');
          const img = card.querySelector('.amhc-pww__img');
          const price = card.querySelector('[data-pww-price]');
          const idInput = card.querySelector('[data-pww-id]');
          const options = Array.prototype.slice.call(card.querySelectorAll('[data-pww-select] option')).map(function (o) { return { id: o.value, label: o.textContent.trim(), cents: Number(o.getAttribute('data-cents') || 0), selected: o.selected, multi: o.getAttribute('data-pww-multi') || '' }; });
          const href = link ? link.getAttribute('href') || '' : '';
          const m = /\/products\/([^/?#]+)/.exec(href);
          return {
            key: 'a' + index, handle: m ? m[1] : '', title: link ? link.textContent.trim() : '', image: img ? img.getAttribute('src') : '',
            cents: price ? Number(price.getAttribute('data-cents') || 0) : 0, from: price ? price.getAttribute('data-from') === '1' : false,
            variantId: idInput ? idInput.value : '', options: options.filter(function (o) { return o.id; })
          };
        }).filter(function (a) { return a.title; });
        // Sale sticker + "Save $X" line exactly as the PDP shows them (they come from the PDP's own sale settings)
        const stk = doc.querySelector('.amhc-sticker');
        const stkText = function (sel) { const el = stk && stk.querySelector(sel); return el ? el.textContent.trim() : ''; };
        const flower = /amh-stk__flower\{[^}]*?url\(['"]?([^'")]+)/.exec(html);
        pdp.sticker = stk ? { top: stkText('.amh-stk__pill'), big: stkText('.amh-stk__flower b'), small: stkText('.amh-stk__flower i'), art: flower ? flower[1] : (root.dataset.saleFlower || '') } : null;
        // First "Save $X · N% off" line (pre-order cards have their own "Save an extra $X" badge)
        const saveEl = Array.prototype.slice.call(doc.querySelectorAll('.amhc-sale-badge__t')).find(function (el) { return /%/.test(el.textContent); });
        pdp.saveText = saveEl ? saveEl.textContent.trim() : '';
        pdp.sections = pdpSectionIds().map(function (id) { return doc.querySelector('[id^="shopify-section-"][id$="__' + id + '"]'); }).filter(Boolean).map(function (el) { return el.outerHTML; });
        pdp.status = 'ready';
        pdp.addons.forEach(function (a) { if (!state.addonPick[a.key] || !a.options.some(function (o) { return o.id === state.addonPick[a.key]; })) { const pre = a.options.find(function (o) { return o.selected; }); state.addonPick[a.key] = pre ? pre.id : (a.variantId || (a.options[0] ? a.options[0].id : '')); } });
        seedAddons();
        if (state.mode === 'result') render(false);
      }).catch(function (err) { if (testMode) window.console.log('[QF TEST] pdp error', err && (err.stack || err)); pdp.status = 'error'; if (state.mode === 'result') render(false); });
    }
    function addonPrice(a) {
      const pick = state.addonPick[a.key];
      const opt = a.options.find(function (o) { return o.id === pick; });
      const cents = opt ? opt.cents : a.cents;
      // data-cents on the PDP cards is already in dollars (the theme's money helper formats it as-is)
      return { full: cents, now: Math.round(cents * (100 - pdp.pct)) / 100, from: !opt && a.from };
    }
    function addonsHTML() {
      if (!config.pdpResult) return '';
      if (pdp.status === 'loading' || pdp.status === 'idle') return '<div class="lqf__setup"><h3 class="lqf__setup-title">Complete your setup</h3><p class="lqf__help">Loading accessories...</p></div>';
      if (!pdp.addons.length) return '';
      const cards = pdp.addons.map(function (a) {
        const pr = addonPrice(a);
        const on = Boolean(state.addons[a.key]);
        const canAdd = Boolean(state.addonPick[a.key]);
        let html = '<div class="lqf__addon' + (on ? ' is-on' : '') + '">';
        html += a.image ? '<img class="lqf__addon-img" src="' + esc(a.image) + '" alt="" loading="lazy">' : '<span class="lqf__addon-img"></span>';
        html += '<span class="lqf__addon-name">' + esc(a.title) + '</span>';
        html += '<span class="lqf__addon-price">' + (pr.from ? 'From ' : '') + money(pr.now) + (pdp.pct ? ' <s>' + money(pr.full) + '</s>' : '') + '</span>';
        if (pdp.pct) html += '<span class="lqf__addon-tag">' + pdp.pct + '% off</span>';
        if (a.options.length) html += '<select class="lqf__addon-select" data-lqf-addon-select="' + a.key + '" aria-label="Option"' + (on ? ' disabled' : '') + '>' + a.options.map(function (o) { return '<option value="' + esc(o.id) + '"' + (state.addonPick[a.key] === o.id ? ' selected' : '') + '>' + esc(o.label) + '</option>'; }).join('') + '</select>';
        html += '<button type="button" class="lqf__addon-add" data-action="addon" data-key="' + a.key + '" aria-pressed="' + on + '"' + (canAdd && !state.cartAdded ? '' : ' disabled') + '>' + (on ? 'Added' : 'Add') + '</button></div>';
        return html;
      }).join('');
      return '<div class="lqf__setup"><h3 class="lqf__setup-title">Complete your setup</h3><div class="lqf__addons">' + cards + '</div><p class="lqf__setup-note">Select your extras and hit Add to cart. The accessory discount is applied automatically at checkout.</p></div>';
    }
    function toggleAddon(key) {
      const a = pdp.addons.find(function (x) { return x.key === key; });
      if (!a) return;
      if (state.addons[key]) { delete state.addons[key]; return; }
      const pick = state.addonPick[key];
      if (!pick) return;
      const opt = a.options.find(function (o) { return o.id === pick; });
      state.addons[key] = { id: pick, handle: a.handle, title: a.title + (opt && a.options.length > 1 ? ' - ' + opt.label : ''), label: addonLabel(a, opt), multi: opt ? opt.multi : '', price: addonPrice(a).now, full: addonPrice(a).full };
    }
    function installSelectHTML() {
      if (!config.installHandle || !config.pdpResult) return '';
      const yes = detail(config.installHandle, 'install');
      const stairs = detail(config.installHandle, 'stairs');
      const current = state.answers.install || 'no';
      let html = '<div class="lqf__install"><div class="lqf__install-head"><span class="lqf__install-icon">' + icon('truck') + '</span><span class="lqf__install-title">' + esc(config.installLabel || 'Installation') + '</span><span class="lqf__install-pill">RECOMMENDED</span></div>';
      if (config.installBlurb) html += '<p class="lqf__install-blurb">' + esc(config.installBlurb) + '</p>';
      html += '<select class="lqf__select" data-lqf-install aria-label="Installation"' + (state.cartAdded ? ' disabled' : '') + '>';
      html += '<option value="no"' + (current === 'no' ? ' selected' : '') + '>No thanks, I\'ll arrange my own</option>';
      if (yes.valid) html += '<option value="yes"' + (current === 'yes' ? ' selected' : '') + '>Yes please, install it for me (' + money(yes.price) + ')</option>';
      if (stairs.valid && stairs.variant !== yes.variant) html += '<option value="stairs"' + (current === 'stairs' ? ' selected' : '') + '>Yes, with stairs (' + money(stairs.price) + ')</option>';
      return html + '</select></div>';
    }
    function mainAnswer() { return category === 'keg' && state.answers.where === 'under' ? choice('where') : mainChoice(); }
    function cardText(text) {
      const vars = Object.assign({}, config.cardVars || {}, (mainAnswer() || {}).vars || {});
      return String(text || '').replace(/\{(\w+)\}/g, function (m, k) { return vars[k] != null ? vars[k] : m; });
    }
    function cardSub() { const a = mainAnswer() || {}; return cardText(a.cardSub != null ? a.cardSub : config.cardSub); }
    function cardUspHTML() {
      const custom = (mainAnswer() || {}).cardUsps || config.cardUsps;
      if (custom) return custom.length ? '<div class="lqf__card-usps">' + custom.map(function (i) { return '<span class="lqf__card-usp"><span class="lqf__trust-icon">' + icon(i[0]) + '</span>' + esc(cardText(i[1])) + '</span>'; }).join('') + '</div>' : '';
      const items = category === 'pool' ? [['truck', 'Installed by our own crews'], ['layers', '20mm honed slate'], ['shield', '24 month warranty']] : [['shield', '24 month warranty'], ['card', 'Interest-free options'], ['phone', 'Real people on the phone']];
      return '<div class="lqf__card-usps">' + items.map(function (i) { return '<span class="lqf__card-usp"><span class="lqf__trust-icon">' + icon(i[0]) + '</span>' + esc(i[1]) + '</span>'; }).join('') + '</div>';
    }
    function renderPdp() {
      // Lives OUTSIDE the landing-page section entirely, so neither the quiz CSS nor lp-canvas restyles the PDP sections
      let box = document.getElementById('lqf-pdp');
      const show = state.mode === 'result' && Boolean(config.pdpResult);
      if (!box) {
        if (!show) return;
        box = document.createElement('div'); box.id = 'lqf-pdp'; box.className = 'lqf-pdp'; box.hidden = true;
        const host = root.closest('.shopify-section') || root.closest('.lp-canvas') || root;
        host.parentNode.insertBefore(box, host.nextSibling);
      }
      if (!show) { box.hidden = true; return; }
      const main = mainHandle();
      if (main && pdp.handle !== main) loadPdp(main);
      if (pdp.status !== 'ready' || box.dataset.handle === pdp.handle) { box.hidden = !(box.dataset.handle && box.dataset.handle === pdp.handle); return; }
      box.innerHTML = pdp.sections.join('');
      box.dataset.handle = pdp.handle;
      const ownReviews = pageReviews(box);
      Array.prototype.slice.call(box.querySelectorAll('script')).forEach(function (old) {
        if (ownReviews && ownReviews.contains(old)) { old.remove(); return; }
        const fresh = document.createElement('script');
        Array.prototype.slice.call(old.attributes).forEach(function (attr) { fresh.setAttribute(attr.name, attr.value); });
        fresh.textContent = old.textContent;
        old.parentNode.replaceChild(fresh, old);
      });
      box.hidden = false;
    }
    // The PDP's Google reviews widget only filters reviews loosely, so on the result page its cards are
    // swapped for this quiz page's own product reviews (the review block under the quiz, with photos).
    function pageReviews(box) {
      const section = box.querySelector('[id$="__google_reviews"]');
      const grev = (root.parentElement && root.parentElement.querySelector('.lp-grev')) || document.querySelector('.lp-grev');
      if (!section || !grev || config.pageReviews === false) return null;
      const cards = Array.prototype.slice.call(grev.querySelectorAll('.lp-grev__card:not([aria-hidden="true"])')).map(function (c) {
        const img = c.querySelector('.lp-grev__media img');
        const av = c.querySelector('.lp-grev__avatar');
        return { name: ((c.querySelector('.lp-grev__meta strong') || {}).textContent || '').trim(), date: ((c.querySelector('.lp-grev__sub') || {}).textContent || '').trim(),
          text: ((c.querySelector('.lp-grev__quote') || {}).textContent || '').trim(), img: img ? img.getAttribute('src') : '', bg: av ? window.getComputedStyle(av).backgroundColor : '#111' };
      }).filter(function (r) { return r.name && r.text; });
      if (!cards.length) return null;
      cards.sort(function (a, b) { return Boolean(b.img) - Boolean(a.img); });
      const star = '<svg viewBox="0 0 24 24" fill="#F4B400"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
      const rail = section.querySelector('#grw-cards');
      const wrap = section.querySelector('#grw-section');
      if (!rail || !wrap) return null;
      rail.innerHTML = cards.map(function (r) {
        const text = r.text.length > 140 ? r.text.slice(0, 140) + '...' : r.text;
        return '<div class="grw-card"><div class="grw-card-top"><span class="grw-card-avatar" style="display:grid;place-items:center;background:' + esc(r.bg) + ';color:#fff;font-size:12px;font-weight:700">' + esc(r.name.charAt(0).toUpperCase()) + '</span><div><div class="grw-card-name">' + esc(r.name) + '</div><div class="grw-card-time">' + esc(r.date) + '</div></div></div>' +
          '<div class="grw-card-stars">' + star.repeat(5) + '</div><p class="grw-card-text">' + esc(text) + '</p>' + (r.img ? '<img class="grw-card-img" src="' + esc(r.img) + '" alt="Customer photo" loading="lazy">' : '') + '</div>';
      }).join('');
      wrap.style.display = 'block';
      const rating = section.querySelector('#grw-rating');
      if (rating) {
        rating.textContent = '4.6/5';
        const x = new XMLHttpRequest();
        x.open('GET', 'https://grw.reputon.com/app/storefront/widget?shop=' + encodeURIComponent((window.Shopify && window.Shopify.shop) || ''));
        x.onload = function () { try { const biz = (JSON.parse(x.responseText).business || [])[0]; if (biz) rating.textContent = (biz.rating || '4.6') + '/5 \u00b7 ' + (biz.reviewsNumber || '500+') + ' reviews'; } catch (_) {} };
        x.send();
      }
      const prev = section.querySelector('#grw-prev'), nextBtn = section.querySelector('#grw-next');
      if (prev) prev.addEventListener('click', function () { rail.scrollLeft -= 292; });
      if (nextBtn) nextBtn.addEventListener('click', function () { rail.scrollLeft += 292; });
      return section;
    }
    function resultHTML() {
      const priced = build();
      const main = priced.items[0];
      if (!main) return '<div class="lqf__quiz"><h2 data-lqf-heading tabindex="-1">Let\'s finish your build</h2><button type="button" class="lqf__text" data-action="back">Back</button></div>';
      let title = main.title;
      if (category === 'pool') title = 'YOUR TABLE: ' + (choice('table') && choice('table').size ? 'SOLID OAK ' + choice('table').size + ' SLATE' : title);
      if (category === 'arcade' && choice('cabinet') && main.handle !== stepById('cabinet').custom.handle) title = choice('cabinet').label + ' PLATINUM UPRIGHT';
      if (category === 'arcade' && choice('cocktail')) title = choice('cocktail').label.toUpperCase() + ' TABLETOP ARCADE';
      if (category === 'arcade' && choice('mix') && main.handle !== stepById('mix').custom.handle) title = choice('mix').label.toUpperCase() + (main.handle.indexOf('cocktail') > -1 ? ' TABLETOP ARCADE' : ' PLATINUM UPRIGHT');
      if (category === 'pinball') title = (choice('machine') || {}).label || title;
      let cardTitle = title;
      if (config.pdpResult && category === 'pinball') title = cardTitle = title + ' VIRTUAL PINBALL';
      if (config.pdpResult && category === 'keg') { cardTitle = main.title; title = state.answers.where === 'under' ? main.title : 'GEN 2.0 KEGERATOR'; }
      else if (category === 'keg') title = (state.answers.where === 'under' ? title : 'GEN 2.0 KEGERATOR') + ', READY TO POUR';
      let content = '<div class="lqf__result-layout"><div class="lqf__result">';
      if (category === 'keg' && state.submitted && state.callChoice !== 'none') content += '<div class="lqf__verdict lqf__confirmation" role="status">' + pill(callStatus()) + '<h2>We\'ll ring you</h2><p>Your set-up is ready below.</p></div>';
      content += '<div class="lqf__result-heading">' + pill(config.resultPill) + '<h1 tabindex="-1" data-lqf-heading>' + esc(title) + (category === 'pinball' && !config.pdpResult ? '<br>VIRTUAL PINBALL' : '') + '</h1></div>';
      if (config.pdpResult) {
        const installItem = priced.items.find(function (i) { return i.handle === config.installHandle; });
        const sale = saleInfo(priced, main);
        content += '<div class="lqf__build-card lqf__build-card--pdp"><div class="lqf__build-top"><div class="lqf__build-media' + (sale.was ? ' lqf__build-media--sale' : '') + '">' + imageHTML(main, 'lqf__build-image').replace('<img ', '<img crossorigin="anonymous" ') + stickerHTML(sale.sticker) + '</div><div class="lqf__build-details">';
        content += '<h3 class="lqf__build-title">' + esc(cardTitle.replace(config.cardTitlePrefix || '', '')) + '</h3>';
        if (category === 'pool' && (choice('table') || {}).colour) content += '<p class="lqf__build-sub">' + esc(choice('table').colour) + '</p>';
        const extras = priced.items.slice(1).filter(function (i) { return i.handle !== config.installHandle; });
        if (config.cardAddonList) { if (extras.length) content += '<p class="lqf__build-sub lqf__build-list">' + extras.map(function (i) { return '<span>+ ' + esc(i.label || i.title) + '</span>'; }).join('') + '</p>'; }
        else if (cardSub()) content += '<p class="lqf__build-sub">' + esc(cardSub()) + '</p>';
        // Keg: the big price is the whole build (accessory discount included) and moves as extras are added or removed
        const priceReady = config.priceIsTotal ? priced.ready : main.valid;
        content += '<div class="lqf__price-row"><p class="lqf__price' + (sale.was && priceReady ? ' lqf__price--sale' : '') + '">' + (priceReady ? money(sale.big) : 'Checking...') + '</p>' + (sale.was && priceReady ? '<s class="lqf__was">' + money(sale.was) + '</s>' : '') + '</div>';
        if (sale.was && priceReady) content += sale.save ? '<span class="lqf__save">' + esc(sale.save) + '</span>' : '<span class="lqf__save lqf__save--wait" aria-hidden="true">&nbsp;</span>';
        if (installItem) content += '<p class="lqf__build-install">+ ' + (installItem.valid ? money(installItem.price) : '...') + ' install by our own crew' + (state.answers.install === 'stairs' ? ', with stairs' : '') + '</p>';
        content += '</div></div>' + cardUspHTML() + installSelectHTML() + addonsHTML() + totalHTML(priced, sale.totalWas);
      } else {
      content += '<div class="lqf__build-card"><div class="lqf__build-top">' + imageHTML(main, 'lqf__build-image') + '<div>';
      if (category === 'pool') content += '<p class="lqf__detail">' + esc((choice('table') || {}).colour) + '</p>';
      if (category !== 'keg' && category !== 'arcade' && category !== 'sauna') content += '<p class="lqf__price">' + (main.valid ? money(main.price) : 'Checking...') + '</p>';
      if (category === 'pinball') content += '<p class="lqf__detail">1300+ tables. 24-month warranty.</p>';
      if (category === 'pool' && state.answers.install !== 'no') {
        const install = priced.items.find(function (i) { return i.handle === config.installHandle; });
        content += '<p class="lqf__detail">Install by our own crew: ' + (install && install.valid ? money(install.price) : 'Checking...') + '</p>';
      }
      content += '</div></div>';
      if (category === 'pool' && !config.pdpResult) {
        const kit = detail(config.kitHandle, (choice('table') || {}).size);
        if (kit.valid) content += '<button type="button" class="lqf__tile lqf__kit" data-action="kit" aria-pressed="' + state.kit + '"' + (state.busy || state.cartAdded ? ' disabled' : '') + '><span>Premium accessory kit · ' + esc((choice('table') || {}).size) + '<span class="lqf__tile-sub">' + money(kit.price) + '</span></span><span class="lqf__tile-check" aria-hidden="true">' + (state.kit ? '✓' : '+') + '</span></button>';
        else if (kit.status === 'loading') content += '<p class="lqf__help">Loading the accessory kit...</p>';
        content += totalHTML(priced);
      }
      if (category === 'keg' || category === 'sauna') content += '<div class="lqf__lines">' + linesHTML(priced) + totalHTML(priced) + '</div>';
      }
      if (category !== 'pool' && category !== 'keg') content += '<span hidden data-lqf-total="' + priced.total + '"></span>';
      const pdpMode = Boolean(config.pdpResult);
      const cartButton = button(state.busy ? 'Adding your build...' : state.cartAdded ? 'Continue to cart' : category === 'pool' || (pdpMode && category === 'keg') ? 'Add my build to cart' : 'Add to cart', 'cart', (!priced.ready || state.busy ? 'disabled ' : '') + 'aria-busy="' + state.busy + '"', category === 'pinball' && !pdpMode ? 'dark' : '');
      content += '<div class="lqf__build-actions">' + (category === 'pinball' && !pdpMode ? '<div class="lqf__desktop-only">' + cartButton + '</div>' : cartButton);
      if (category === 'arcade' && !pdpMode) content += button('Rather talk it through? Get a call', 'callback', '', 'dark');
      if (category === 'keg' && !state.submitted && !pdpMode) content += '<button type="button" class="lqf__text" data-action="venue">Pouring for a pub or club? Talk to our team</button>';
      content += '</div><p class="lqf__error" role="status">' + esc(state.cartError) + '</p>' + (!priced.ready ? retryProductsHTML() : '') + '</div>';
      if (config.pdpResult) {}
      else if (category === 'arcade' || category === 'keg') content += trustHTML(false);
      else content += '<div class="lqf__desktop-only lqf__result-trust">' + trustHTML(category === 'pool') + '</div>';
      content += '</div>';
      if (category !== 'keg' || pdpMode) content += specialistsHTML();
      else content += '<div class="lqf__desktop-only lqf__result-specialists">' + specialistsHTML() + '</div>';
      if (category === 'pinball' && !pdpMode) content += '<div class="lqf__result lqf__build-actions lqf__mobile-result-action">' + cartButton + '</div>';
      return content + '</div>';
    }
    function renderRunning() {
      const running = false; // keg running total bar off: no prices during the quiz
      root.classList.toggle('lqf--running', running);
      const priced = build();
      root.classList.toggle('lqf--running-items', running && priced.items.length > 1);
      q('[data-lqf-running]').hidden = !running;
      if (!running) return;
      q('[data-lqf-running]').innerHTML = (priced.items.length > 1 ? '<div class="lqf__running-lines">' + linesHTML(priced) + '</div>' : '') + '<div class="lqf__running-inner"><div><span class="lqf__caps">YOUR BUILD</span><strong class="lqf__running-price">' + (priced.items.length && !priced.ready ? 'Checking...' : money(priced.total)) + '</strong></div>' + button('Next', 'next', canAdvance(currentStep()) ? '' : 'disabled') + '</div>';
    }
    function render(focusHeading) {
      const active = document.activeElement;
      const action = active && root.contains(active) ? active.getAttribute('data-action') : null;
      const value = action && active.getAttribute('data-value');
      const desktop = window.matchMedia('(min-width: 1024px)').matches;
      const intro = state.mode === 'quiz' && state.step === 0;
      if (state.mode === 'quiz') preselect(currentStep());
      root.classList.toggle('lqf--intro', intro);
      root.classList.toggle('lqf--pdp', Boolean(config.pdpResult));
      root.classList.toggle('lqf--result', state.mode === 'result');
      q('[data-lqf-hero]').hidden = !intro;
      q('[data-lqf-gallery]').hidden = state.mode !== 'result' || category === 'keg' || category === 'sauna' || Boolean(config.pdpResult);
      stage.innerHTML = state.mode === 'result' ? resultHTML() : state.mode === 'contact' ? contactHTML() : stepHTML();
      if (intro && category === 'pool') stage.insertAdjacentHTML('beforeend', trustHTML(true));
      else if (state.mode !== 'result') stage.insertAdjacentHTML('beforeend', '<div class="' + (category === 'pool' || category === 'pinball' || category === 'arcade' || category === 'sauna' ? '' : 'lqf__desktop-only ') + 'lqf__quiz-trust">' + trustHTML(category === 'pool') + '</div>');
      renderRunning();
      if (config.pdpResult && state.mode === 'contact') { const h = mainHandle(); if (h && pdp.handle !== h) loadPdp(h); }
      renderPdp();
      tintMedia();
      saveNote();
      if (focusHeading) {
        const heading = q('[data-lqf-heading]');
        if (heading) heading.focus({ preventScroll: true });
        const content = q('[data-lqf-content]');
        if (content && state.mode !== 'result' && desktop) content.scrollTop = 0;
        else stage.scrollIntoView({ behavior: 'instant', block: 'start' });
        if (animation) animation.cancel();
        if (stage.animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) animation = stage.animate([{ opacity: .25, transform: 'translateY(12px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 200, easing: 'ease-out' });
      } else if (action && !dialog.open) {
        const target = Array.from(root.querySelectorAll('[data-action]')).find(function (el) { return el.getAttribute('data-action') === action && el.getAttribute('data-value') === value && !el.closest(desktop ? '.lqf__mobile-result-action' : '.lqf__desktop-only'); });
        if (target) target.focus({ preventScroll: true });
      }
    }
    function next() {
      if (state.mode !== 'quiz' || !canAdvance(currentStep())) return;
      state.error = '';
      const done = currentStep();
      ga4('quiz_step_complete', { step_number: state.step + 1, total_steps: steps().length, step_id: done.id, question: String(done.question || '').slice(0, 100), answer: answerText(done) });
      if (state.step + 1 < steps().length) state.step += 1;
      else { state.mode = 'contact'; ga4('view_contact'); }
      render(true);
    }
    function back() {
      if (state.mode === 'result' || state.submitted) return;
      if (state.mode === 'contact') state.mode = 'quiz';
      else if (state.step > 0) state.step -= 1;
      state.error = '';
      render(true);
    }
    // GA4 funnel events (AMHC 13 Oct 2026, for Adam's event-based funnels). Sent to the site's GA4 property only.
    function ga4(name, params) {
      const data = Object.assign({ quiz: category, quiz_variant: config.variant }, params || {});
      if (testMode) { window.console.log('[QF TEST] ga4', name, data); return; }
      try {
        if (typeof window.gtag !== 'function') return;
        const cfg = (window.dataLayer || []).find(function (x) { return x && x[0] === 'config' && /^G-/.test(String(x[1])); });
        if (cfg) data.send_to = cfg[1];
        window.gtag('event', name, data);
      } catch (_) {}
    }
    function answerText(step) {
      const pick = function (group) {
        const ids = group.multi ? (state.answers[group.id] || []) : [state.answers[group.id]];
        return ids.filter(Boolean).map(function (id) { const a = options(group).find(function (x) { return x.id === id; }); return a ? a.label : id; });
      };
      const out = step.groups ? step.groups.reduce(function (all, g) { return all.concat(pick(g)); }, []) : pick(step);
      if (step.followup && state.answers[step.followup.id]) out.push(pick(step.followup).join(', '));
      return out.join(', ').slice(0, 100);
    }
    function track() {
      const args = Array.from(arguments);
      if (testMode) { window.console.log('[QF TEST] fbq', args); return; }
      try { if (typeof window.fbq === 'function') window.fbq.apply(window, args); } catch (_) {}
    }
    function saveNote() {
      const note = q('[data-lqf-save]');
      note.hidden = state.mode !== 'result' || !outbox.length;
      if (note.hidden) return;
      note.innerHTML = outbox[0].failed ? 'Your build is ready. We couldn\'t save your details. <button type="button" class="lqf__text" data-action="retry-intake">Try saving again</button>' : 'Saving your details…';
    }
    async function sendOutbox() {
      if (sending || !outbox.length || outbox[0].failed) return;
      sending = true;
      const entry = outbox[0];
      for (let attempt = 0; attempt < 3; attempt += 1) {
        const controller = typeof AbortController === 'function' ? new AbortController() : null;
        let timeout;
        try {
          const response = await Promise.race([
            window.fetch(root.dataset.intakeUrl || 'https://amahc-crm.vercel.app/api/intake/quiz', {
              method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(entry.payload), keepalive: true,
              ...(controller ? { signal: controller.signal } : {})
            }),
            new Promise(function (_, reject) { timeout = setTimeout(function () { if (controller) controller.abort(); reject(new Error('Intake timeout')); }, 10000); })
          ]);
          if (!response.ok) throw new Error('Intake unavailable');
          clearTimeout(timeout);
          outbox.shift();
          break;
        } catch (_) {
          clearTimeout(timeout);
          if (attempt === 2) entry.failed = true;
          else await new Promise(function (resolve) { setTimeout(resolve, (attempt + 1) * 1000); });
        }
      }
      sending = false;
      saveNote();
      if (outbox.length && !outbox[0].failed) sendOutbox();
    }
    function intake(payload, name) {
      if (testMode) { window.console.log('[QF TEST] ' + name, payload); return; }
      outbox.push({ payload: payload, failed: false });
      saveNote();
      sendOutbox();
    }
    function payload() {
      const priced = build();
      const intent = choice('intent');
      const tracking = attribution();
      const answers = {};
      const lines = ['Category: ' + config.label, 'Funnel: Quiz funnel (' + config.variant + ')'];
      steps().forEach(function (step) { // only the steps this person actually saw
        if (step.groups) {
          const ids = [];
          const labels = [];
          step.groups.forEach(function (g) {
            g.answers.forEach(function (a) {
              if (g.multi ? (state.answers[g.id] || []).includes(a.id) : state.answers[g.id] === a.id) { ids.push(a.id); labels.push(a.label); }
            });
          });
          answers[step.id] = ids;
          lines.push(step.question + ': ' + labels.join(', '));
        } else if (state.answers[step.id]) {
          answers[step.id] = state.answers[step.id];
          const a = choice(step.id);
          if (step.id !== 'intent') lines.push(step.question + ': ' + (step.liveTitle && a.handle ? cleanTitle(detail(a.handle).product.title) : a.label));
          if (step.followup && state.answers[step.followup.id]) {
            answers[step.followup.id] = state.answers[step.followup.id];
            lines.push(step.followup.question + ': ' + step.followup.answers.find(function (f) { return f.id === state.answers[step.followup.id]; }).label);
          }
        }
      });
      lines.push('Build:');
      priced.items.forEach(function (i) { lines.push(i.title + ': ' + money(i.price)); });
      lines.push('Total: ' + money(priced.total), 'Timing: ' + intent.label);
      return {
        ...state.contact, message: lines.join('\n'), form_title: 'AMAHC · Quiz funnel · ' + config.label,
        page_url: window.location.href, landingurl: tracking.landingurl, vid: tracking.vid,
        quiz: {
          submission_id: state.id, variant: config.variant, category: config.category, funnel: 'quiz-funnel',
          intent: intent.id, qualified: intent.qualified === true, answers: answers,
          build: priced.items.map(function (i) { return { handle: i.handle, variant_id: i.variant_id, title: i.title, price: i.price / 100 }; }),
          build_total: priced.total / 100, fbp: tracking.fbp, fbc: tracking.fbc
        }
      };
    }
    function submitContact() {
      if (state.submitted || state.mode !== 'contact') return;
      const contact = { first_name: state.contact.first_name.trim(), phone: state.contact.phone.replace(/\s/g, ''), email: state.contact.email.trim() };
      state.errors = {};
      if (!contact.first_name) state.errors.first_name = 'Pop in your first name.';
      if (!/^(?:04\d{8}|\+614\d{8}|0[2378]\d{8})$/.test(contact.phone)) state.errors.phone = "That doesn't look like an Aussie number";
      if (contact.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contact.email)) state.errors.email = 'Enter a valid email address.';
      if (Object.keys(state.errors).length) {
        render(false);
        q('[aria-invalid="true"]').focus();
        return;
      }
      if (!choice('intent') || !build().ready) {
        state.error = 'Please finish your timing and product choices first.';
        render(false);
        return;
      }
      contact.phone = contact.phone.startsWith('0') ? '+61' + contact.phone.slice(1) : contact.phone;
      state.contact = contact;
      state.id = state.id || uuid();
      state.submitted = true;
      const data = payload();
      intake(data, 'POST 1');
      ga4('generate_lead', { intent: data.quiz.intent, qualified: Boolean(data.quiz.qualified), currency: 'AUD', value: Math.round(build().total) / 100 });
      track(data.quiz.qualified ? 'track' : 'trackCustom', data.quiz.qualified ? 'Lead' : 'QuizComplete', { content_name: config.label + ' quiz', intent: data.quiz.intent }, { eventID: (data.quiz.qualified ? 'amahc-lead-' : 'amahc-quiz-') + state.id });
      const identify = ['identify', { $email: contact.email, $phone_number: contact.phone, $first_name: contact.first_name }];
      const complete = ['track', 'Quiz Funnel Complete', { category: config.category, variant: config.variant, intent: data.quiz.intent, submission_id: state.id, build_total: data.quiz.build_total }];
      if (testMode) window.console.log('[QF TEST] Klaviyo', [identify, complete]);
      else {
        try { if (window._learnq) { window._learnq.push(identify); window._learnq.push(complete); } } catch (_) {}
      }
      openDialog();
    }
    function availableWindows() {
      return windows.filter(function (_, index) { return state.callDay !== state.clock.today || state.clock.minute < [12 * 60, 14 * 60, 17 * 60][index]; });
    }
    function dialogHTML() {
      return '<h2 id="' + uid + '-call-title" tabindex="-1">BESHOY OR LACHLAN WILL RING YOU</h2><p class="lqf__call-time">' + (state.clock.open ? 'in the next few minutes' : 'first thing ' + esc(state.clock.weekday) + ' morning') + '</p>' +
        button(state.clock.open ? 'YES, CALL ME NOW' : 'YES, CALL ME FIRST THING', 'call-now') + button('PICK A TIME INSTEAD', 'schedule', 'aria-expanded="' + state.schedule + '" aria-controls="' + uid + '-schedule"', 'dark') +
        '<div class="lqf__schedule" id="' + uid + '-schedule"' + (state.schedule ? '' : ' hidden') + '><p class="lqf__help">All times are Sydney time.</p><fieldset class="lqf__group"><legend>Pick a day</legend><div class="lqf__days">' + state.clock.days.map(function (day) {
          return '<button type="button" class="lqf__day" data-action="call-day" data-value="' + day.id + '" aria-pressed="' + (state.callDay === day.id) + '">' + (day.today ? 'Today' : esc(day.label)) + '</button>';
        }).join('') + '</div></fieldset><fieldset class="lqf__group"><legend>Pick a window</legend><div class="lqf__days">' + availableWindows().map(function (label) {
          return '<button type="button" class="lqf__day" data-action="call-window" data-value="' + esc(label) + '" aria-pressed="' + (state.callWindow === label) + '">' + esc(label) + '</button>';
        }).join('') + '</div></fieldset>' + button('BOOK THIS TIME', 'call-book', state.callDay && state.callWindow ? '' : 'disabled') + '</div>' +
        '<button type="button" class="lqf__text lqf__decline" data-action="call-none">No thanks, just show me my build</button>';
    }
    function renderDialog(action, value) {
      dialogContent.innerHTML = dialogHTML();
      if (action) {
        const target = Array.from(dialog.querySelectorAll('[data-action]')).find(function (el) { return el.dataset.action === action && (!value || el.dataset.value === value); });
        if (target) target.focus();
      }
    }
    function openDialog() {
      if (!state.submitted) return;
      state.clock = sydney(new Date(), root.dataset.hours);
      state.schedule = false;
      state.callDay = '';
      state.callWindow = '';
      state.callDone = false;
      restoreFocus = document.activeElement;
      dialog.setAttribute('aria-labelledby', uid + '-call-title');
      dialog.classList.toggle('lqf__dialog--venue', state.answers.who === 'venue' || state.answers.where === 'venue');
      renderDialog();
      if (!dialog.open) dialog.showModal();
      dialog.querySelector('h2').focus();
    }
    function chooseCall(selected) {
      if (state.callDone || !dialog.open) return;
      if (selected === 'scheduled' && (!state.callDay || !availableWindows().includes(state.callWindow))) return;
      state.callDone = true;
      state.callChoice = selected;
      const quiz = { submission_id: state.id, variant: config.variant, call_choice: selected };
      if (selected === 'scheduled') {
        state.callSlot = state.clock.days.find(function (day) { return day.id === state.callDay; }).label + ', ' + state.callWindow;
        quiz.call_slot = state.callSlot;
      } else state.callSlot = '';
      intake({ quiz: quiz }, 'POST 2');
      track('trackCustom', 'QuizCallChoice', { choice: selected });
      ga4('call_choice', { choice: selected });
      dialog.close();
      showResult();
      render(true);
      if (restoreFocus && restoreFocus.isConnected && restoreFocus.dataset.action === 'callback') restoreFocus.focus({ preventScroll: true });
    }
    function showResult() {
      state.mode = 'result';
      if (!state.resultTracked) { state.resultTracked = true; const pr = build(); ga4('view_result', { product: (pr.items[0] || {}).title || '', currency: 'AUD', value: Math.round(pr.total) / 100 }); }
      if (category === 'keg' && !state.submitted && !state.cartComplete) {
        state.cartComplete = true;
        track('trackCustom', 'QuizComplete', { category: 'kegerators', path: 'cart' });
      }
    }
    async function addToCart() {
      const priced = build();
      if (!priced.ready || state.busy) return;
      state.id = state.id || uuid();
      if (!state.cartAdded) ga4('quiz_add_to_cart', { currency: 'AUD', value: Math.round(priced.total) / 100, items: priced.items.map(function (i) { return { item_id: String(i.variant_id || ''), item_name: i.title, price: Math.round(i.price || 0) / 100, quantity: 1 }; }) });
      const add = { items: priced.items.reduce(function (all, i) { return all.concat((i.ids && i.ids.length ? i.ids : [i.variant_id]).map(function (id) { return { id: id, quantity: 1 }; })); }, []) };
      const update = { attributes: { _quiz_submission_id: state.id, _quiz_variant: config.variant } };
      if (testMode) {
        window.console.log('[QF TEST] /cart/add.js', add);
        window.console.log('[QF TEST] /cart/update.js', update);
        window.console.log('[QF TEST] navigate', '/cart');
        return;
      }
      state.busy = true;
      state.cartError = '';
      render(false);
      try {
        if (!state.cartAdded) {
          const response = await window.fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(add) });
          if (!response.ok) throw new Error('We couldn\'t add your build. Please try again.');
          state.cartAdded = true;
        }
        const response = await window.fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(update) });
        if (!response.ok) throw new Error('Your items are in the cart. Tap Continue to cart to finish saving your build.');
        window.location.assign('/cart');
      } catch (error) {
        state.cartError = error.message || 'We couldn\'t reach the cart. Please try again.';
        state.busy = false;
        render(false);
      }
    }
    // Desktop: put the top of the quiz section at the top of the window so the site header scrolls out of view
    function scrollPastHeader() {
      const top = root.getBoundingClientRect().top + window.scrollY;
      if (Math.abs(window.scrollY - top) > 4) window.scrollTo({ top: top, behavior: 'smooth' });
    }
    function answer(id, value) {
      if (state.mode !== 'quiz') return;
      if (!state.started) { state.started = true; ga4('start_quiz'); }
      const step = currentStep();
      const group = step.id === id ? step : (step.groups || []).find(function (g) { return g.id === id; }) || (step.followup && step.followup.id === id ? step.followup : null);
      if (!group) return;
      const a = options(group).find(function (item) { return item.id === value; });
      if (!a || (a.handle && !detail(a.handle).valid)) return;
      if (group.multi) {
        const selected = state.answers[id] || [];
        state.answers[id] = selected.includes(value) ? selected.filter(function (s) { return s !== value; }) : selected.concat(value);
      } else {
        if (state.answers[id] !== value) config.steps.forEach(function (s) { if (s.preselect && s.preselect.step === id) delete state.answers[s.id]; });
        state.answers[id] = value;
      }
      config.steps.forEach(function (s) { if (s.showIf && state.answers[s.showIf.step] !== s.showIf.answer) delete state.answers[s.id]; });
      if (id === 'level') {
        if (value === 'ground') delete state.answers.tight;
        else state.answers.tight = state.answers.tight || 'no';
      }
      state.error = '';
      render(false);
    }
    root.addEventListener('input', function (event) {
      const field = event.target.dataset.contact;
      if (field && Object.prototype.hasOwnProperty.call(state.contact, field)) state.contact[field] = event.target.value;
    });
    root.addEventListener('change', function (event) {
      if (event.target.hasAttribute('data-lqf-install')) { state.answers.install = event.target.value; render(false); }
      else if (event.target.hasAttribute('data-lqf-addon-select')) { state.addonPick[event.target.getAttribute('data-lqf-addon-select')] = event.target.value; render(false); }
    });
    root.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' && event.target.dataset.contact && !dialog.open) { event.preventDefault(); submitContact(); }
    });
    root.addEventListener('click', function (event) {
      const target = event.target.closest('[data-action]');
      if (!target || !root.contains(target) || target.disabled) return;
      event.preventDefault();
      const action = target.dataset.action;
      const value = target.dataset.value;
      if (action === 'answer') {
        answer(target.dataset.step, value);
        if (category === 'pool' && target.dataset.step === 'room' && value === 'under' && (choice('table') || {}).size === '8ft') { delete state.answers.table; render(false); }
        // Bring the whole quiz card into view so the result of the tap is visible
        if (window.matchMedia('(max-width: 1023px)').matches) {
          const nextButton = root.querySelector('[data-lqf-stage] [data-action="next"]');
          const stage = root.querySelector('[data-lqf-stage]');
          if (category === 'pinball' && target.dataset.step === 'brand' && stage) { const h = document.querySelector('.header, .site-header, header'); const hh = h && getComputedStyle(h).position === 'sticky' || h && getComputedStyle(h).position === 'fixed' ? h.getBoundingClientRect().height : 0; window.scrollTo({ top: stage.getBoundingClientRect().top + window.scrollY - hh - 8, behavior: 'smooth' }); }
          else if (nextButton) nextButton.scrollIntoView({ behavior: 'smooth', block: 'end' });
          else if (stage) stage.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else scrollPastHeader();
      }
      else if (action === 'next') { next(); if (window.matchMedia('(min-width: 1024px)').matches) scrollPastHeader(); }
      else if (action === 'back') { back(); if (window.matchMedia('(min-width: 1024px)').matches) scrollPastHeader(); }
      else if (action === 'submit') submitContact();
      else if (action === 'callback') { if (state.submitted) ga4('request_callback', { placement: state.mode }); openDialog(); }
      else if (action === 'reviews') { const r = document.getElementById('reviews'); if (r) r.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      else if (action === 'schedule') { state.schedule = !state.schedule; renderDialog('schedule'); }
      else if (action === 'call-day') {
        state.callDay = value;
        if (!availableWindows().includes(state.callWindow)) state.callWindow = '';
        renderDialog(action, value);
      } else if (action === 'call-window') { state.callWindow = value; renderDialog(action, value); }
      else if (action === 'call-now') chooseCall('now');
      else if (action === 'call-none') chooseCall('none');
      else if (action === 'call-book') chooseCall('scheduled');
      else if (action === 'kit' && !state.cartAdded) { state.kit = !state.kit; render(false); }
      else if (action === 'addon' && !state.cartAdded) { toggleAddon(target.dataset.key); render(false); }
      else if (action === 'cue' && !state.cartAdded) { state.cue = !state.cue; render(false); }
      else if (action === 'cart') addToCart();
      else if (action === 'venue') {
        if (state.submitted) openDialog();
        else { state.leadPath = true; state.mode = 'quiz'; state.step = steps().findIndex(function (s) { return s.id === 'intent'; }); render(true); }
      } else if (action === 'retry-products') {
        allHandles().forEach(function (handle) { const p = products.get(handle); if (!p || p.status === 'error' || (p.status === 'ready' && !detail(handle).valid)) { products.delete(handle); loadProduct(handle); } });
        render(false);
      } else if (action === 'retry-intake') { outbox.forEach(function (entry) { entry.failed = false; }); sendOutbox(); }
    });
    dialog.addEventListener('cancel', function (event) { event.preventDefault(); chooseCall('none'); });
    root.addEventListener('click', function (event) { const tel = event.target.closest('a[href^="tel:"]'); if (tel && root.contains(tel)) ga4('call_click', { placement: state.mode }); });
    dialog.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab') return;
      const focusable = Array.from(dialog.querySelectorAll('button:not([disabled]), a[href], input:not([disabled])')).filter(function (el) { return !el.closest('[hidden]'); });
      if (!focusable.length) { event.preventDefault(); return; }
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || !focusable.includes(document.activeElement))) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !focusable.includes(document.activeElement))) { event.preventDefault(); first.focus(); }
    });
    if (typeof dialog.showModal !== 'function' || typeof window.fetch !== 'function') throw new Error('Quiz needs a current browser');
    allHandles().forEach(loadProduct);
    q('[data-lqf-test]').hidden = !testMode;
    mountNativeHeader(root);
    if (new URLSearchParams(window.location.search).get('qf_font') === 'mona') {
      root.classList.add('lqf--mona');
      if (!document.querySelector('link[data-lqf-mona]')) {
        const link = document.createElement('link');
        link.rel = 'stylesheet'; link.setAttribute('data-lqf-mona', '');
        link.href = 'https://fonts.googleapis.com/css2?family=Mona+Sans:ital,wdth,wght@0,112.5,900;1,112.5,900&family=Figtree:wght@400;500;600;800&display=swap';
        document.head.appendChild(link);
      }
    }
    renderHero();
    render(false);
    q('[data-lqf-app]').hidden = false;
    q('[data-lqf-fallback]').hidden = true;
  }

  function mountNativeHeader(root) {
    // The funnel uses the store's own header. On desktop the call group sits in the search row.
    const template = root.querySelector('template[data-lqf-native-call]');
    const search = document.querySelector('header form.tagsrch');
    if (template && search && !document.querySelector('.lqf-native-cta')) search.insertAdjacentElement('afterend', template.content.firstElementChild.cloneNode(true));
    const section = document.querySelector('.shopify-section-group-header-group[id$="__header"]') || document.querySelector('.shopify-section-group-header-group');
    if (!section) { root.style.setProperty('--header-height', '0px'); return; }
    const measure = function () { root.style.setProperty('--header-height', Math.max(0, Math.round(section.getBoundingClientRect().bottom + window.scrollY)) + 'px'); };
    measure();
    if (typeof window.ResizeObserver === 'function') new window.ResizeObserver(measure).observe(section);
    window.addEventListener('load', measure);
  }

  function init(scope) {
    const roots = Array.from(scope.querySelectorAll('[data-lqf]'));
    if (scope.matches && scope.matches('[data-lqf]')) roots.unshift(scope);
    roots.forEach(function (root) {
      if (instances.has(root)) return;
      try { create(root); instances.add(root); } catch (error) { window.console.warn('Quiz funnel could not start:', error); }
    });
  }
  window.__amahcQuizFunnel = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
}());

